import { Lock } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { CommandItem } from '@/components/ui/command'
import { HiddenBadge } from '@/features/snippets/HiddenBadge'
import type { Snippet } from '@/features/snippets/types'
import { isCopyOfShared } from '@/features/snippets/utils'

/** One row: a lock for a Careforce snippet, a badge for the org's own copy. */
export function SnippetPickerItem({
  snippet,
  preview,
  onSelect,
}: {
  snippet: Snippet
  preview: string
  onSelect: (snippet: Snippet) => void
}) {
  return (
    <CommandItem
      value={snippet.name}
      keywords={[preview]}
      onSelect={() => onSelect(snippet)}>
      {snippet.read_only && (
        <Lock
          aria-hidden="true"
          className="size-4 shrink-0 text-neutral-low-contrast"
        />
      )}
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="flex min-w-0 items-center gap-2">
          <span className="truncate font-medium" title={snippet.name}>
            {snippet.name}
          </span>
          {isCopyOfShared(snippet) && (
            <Badge variant="success">Customized</Badge>
          )}
          {snippet.is_hidden && <HiddenBadge />}
        </span>
        <span className="truncate text-xs text-muted-foreground">
          {preview}
        </span>
      </div>
    </CommandItem>
  )
}
